/**
 * Demo templates — ported from reactjs/src/lib/data/demoTemplates.ts.
 * Field names and values copied character-for-character.
 */
import type { DemoTemplate } from "@/modes/draft/types";

export const demoTemplates: DemoTemplate[] = [
  {
    id: "t3",
    title: "S&OP Monthly Executive Deck",
    description: "Monthly S&OP review presentation with demand, supply, and financial views",
    category: "Operations & Planning",
    format: "PPT",
    sections: 8,
    rating: 4.8,
    uses: 1800,
    timeEstimate: "~40 min",
    domain: "S&OP",
  },
  {
    id: "t22",
    title: "Excess and Obsolete Inventory Policy Guide",
    description: "Guidelines and best practices to manage excess and obsolete inventory effectively",
    category: "Operations & Planning",
    format: "DOCX",
    sections: 8,
    rating: 4.5,
    uses: 600,
    timeEstimate: "~35 min",
    domain: "Inventory",
  },
  {
    id: "t7",
    title: "The Definitive Guide to Warehousing",
    description: "Strategies for maximum efficiency in warehouse operations and management",
    category: "Logistics & Transport",
    format: "DOCX",
    sections: 10,
    rating: 4.7,
    uses: 1200,
    timeEstimate: "~45 min",
    domain: "Warehousing",
  },
  {
    id: "t8",
    title: "Stocktaking Procedures Guide",
    description: "The ultimate guide to accurate inventory counts and stocktaking procedures",
    category: "Operations & Planning",
    format: "DOCX",
    sections: 8,
    rating: 4.6,
    uses: 850,
    timeEstimate: "~35 min",
    domain: "Inventory",
  },
  {
    id: "t9",
    title: "Reverse Logistics Management Guide",
    description: "Managing supply chain the other way around with reverse logistics strategies",
    category: "Logistics & Transport",
    format: "DOCX",
    sections: 9,
    rating: 4.6,
    uses: 780,
    timeEstimate: "~40 min",
    domain: "Reverse Logistics",
  },
  {
    id: "t10",
    title: "Procurement 101: Guide to Procurement Success",
    description: "Your complete guide to procurement fundamentals and best practices",
    category: "Capability & Training",
    format: "DOCX",
    sections: 10,
    rating: 4.8,
    uses: 1600,
    timeEstimate: "~45 min",
    domain: "Procurement",
  },
  {
    id: "t11",
    title: "Plan for Every Part Template (PFEP Guide)",
    description: "Detailed PFEP template for parts planning and inventory management",
    category: "Operations & Planning",
    format: "DOCX",
    sections: 6,
    rating: 4.5,
    uses: 620,
    timeEstimate: "~30 min",
    domain: "Inventory Planning",
  },
  {
    id: "t12",
    title: "Enhanced Supplier Development Framework",
    description: "Enhanced supplier development framework and methodologies",
    category: "Supplier Management",
    format: "DOCX",
    sections: 15,
    rating: 4.7,
    uses: 1100,
    timeEstimate: "~60 min",
    domain: "Supplier Development",
  },
  {
    id: "t13",
    title: "Optimize Your Inventory: Planning Methods Guide",
    description: "A guide to inventory planning methods and optimization strategies",
    category: "Operations & Planning",
    format: "DOCX",
    sections: 8,
    rating: 4.6,
    uses: 720,
    timeEstimate: "~35 min",
    domain: "Inventory Optimization",
  },
  {
    id: "t14",
    title: "ESG in Procurement",
    description: "Environmental, social, and governance considerations in procurement",
    category: "Strategy & Governance",
    format: "DOCX",
    sections: 8,
    rating: 4.6,
    uses: 650,
    timeEstimate: "~40 min",
    domain: "ESG",
  },
  {
    id: "t15",
    title: "Demand Forecasting Methods - Ultimate Guide 2025",
    description: "The ultimate guide to demand forecasting methods and techniques",
    category: "Operations & Planning",
    format: "DOCX",
    sections: 10,
    rating: 4.8,
    uses: 1400,
    timeEstimate: "~50 min",
    domain: "Forecasting",
  },
  {
    id: "t16",
    title: "Artificial Intelligence in Procurement - Volume 2",
    description: "Advanced AI applications and strategies in procurement",
    category: "Strategy & Governance",
    format: "DOCX",
    sections: 12,
    rating: 4.7,
    uses: 980,
    timeEstimate: "~50 min",
    domain: "AI",
  },
  {
    id: "t17",
    title: "Artificial Intelligence in Procurement - Volume 1",
    description: "Introduction to AI applications in procurement processes",
    category: "Strategy & Governance",
    format: "DOCX",
    sections: 11,
    rating: 4.7,
    uses: 1050,
    timeEstimate: "~45 min",
    domain: "AI",
  },
  {
    id: "t18",
    title: "5S Kaizen Guide: Organizing the Workplace for Flow",
    description: "Workplace organization guide using 5S Kaizen methodology",
    category: "Process & SOPs",
    format: "DOCX",
    sections: 5,
    rating: 4.5,
    uses: 550,
    timeEstimate: "~25 min",
    domain: "Lean",
  },
  {
    id: "t19",
    title: "Supplier Excellence Manual",
    description: "Comprehensive manual outlining best practices, frameworks, and tools for achieving supplier excellence",
    category: "Supplier Management",
    format: "DOCX",
    sections: 10,
    rating: 4.7,
    uses: 890,
    timeEstimate: "~55 min",
    domain: "Supplier Excellence",
  },
  {
    id: "t21",
    title: "Six Sigma Project Examples to Get You Certified",
    description: "Practical Six Sigma project examples aligned with certification requirements and DMAIC methodology",
    category: "Process & SOPs",
    format: "DOCX",
    sections: 10,
    rating: 4.6,
    uses: 750,
    timeEstimate: "~45 min",
    domain: "Six Sigma",
  },
  {
    id: "t6",
    title: "The Most Complete Supply Chain Terms and Glossary",
    description: "Comprehensive glossary of supply chain terminology and definitions",
    category: "Capability & Training",
    format: "DOCX",
    sections: 12,
    rating: 4.9,
    uses: 2100,
    timeEstimate: "~50 min",
    domain: "Knowledge",
  },
];

export function getCategoryCounts(): Record<string, number> {
  const counts: Record<string, number> = {};
  demoTemplates.forEach((template) => {
    counts[template.category] = (counts[template.category] || 0) + 1;
  });
  return counts;
}

export function getTemplatesByCategory(category: string): DemoTemplate[] {
  return demoTemplates.filter((t) => t.category === category);
}
